// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"3d9acb18","administration":"57793941"}[chunkId] + ".chunk.js";
};